export var DEFAULT_PHONE_LAYOUT = "temporary";
export var DEFAULT_TABLET_LAYOUT = "toggleable";
export var DEFAULT_LANDSCAPE_TABLET_LAYOUT = "toggleable";
export var DEFAULT_DESKTOP_LAYOUT = "full-height";
export var DEFAULT_LAYOUT_MAIN_CLASSNAMES = {
    enter: "rmd-layout-transition--enter",
    enterActive: "rmd-layout-main--nav-offset",
    enterDone: "rmd-layout-main--nav-offset",
    exit: "rmd-layout-transition--exit",
};
export var DEFAULT_LAYOUT_NAV_TOGGLE_CLASSNAMES = {
    enter: "rmd-layout-transition--enter",
    enterActive: "rmd-layout-nav-toggle--offset",
    enterDone: "rmd-layout-nav-toggle--offset",
    exit: "rmd-layout-transition--exit",
};
/** @deprecated \@since 5.1.3 use `DEFAULT_LAYOUT_NAV_TOGGLE_CLASSNAMES` instead */
export var DEFFAULT_LAYOUT_NAV_TOGGLE_CLASSNAMES = DEFAULT_LAYOUT_NAV_TOGGLE_CLASSNAMES;
//# sourceMappingURL=constants.js.map